/* Progressive enhancement: the complete description remains available without JS. */
(() => {
  if (customElements.get('daayraa-product-accordions')) return;

  class DaayraaProductAccordions extends HTMLElement {
    connectedCallback() {
      if (this.initialized || !this.hasAttribute('data-split-description')) return;
      const source = this.querySelector('[data-description-source]');
      const originalRow = this.querySelector('[data-description-row]');
      if (!source || !originalRow) return;
      this.initialized = true;

      // Match whole headings only; ordinary sentences mentioning care are untouched.
      const categories = new Map([
        ['description', 'description'], ['product description', 'description'],
        ['details', 'details'], ['product details', 'details'],
        ['care', 'care'], ['care instructions', 'care'], ['product care', 'care'],
      ]);
      const headings = Array.from(source.querySelectorAll('p, h1, h2, h3, h4, h5, h6')).flatMap(element => {
        if (element.closest('li, table, blockquote')) return [];
        const label = element.textContent.replace(/\s+/g, ' ').trim().replace(/:$/, '').toLowerCase();
        const category = categories.get(label);
        return category ? [{ element, category }] : [];
      });
      if (!headings.length) return;

      try {
        const sections = new Map();
        const addSection = (category, start, end) => {
          const range = document.createRange();
          range.selectNodeContents(source);
          if (start) range.setStartAfter(start);
          if (end) range.setEndBefore(end);
          const content = range.cloneContents();
          // Ignore empty editor markup, but preserve images and other meaningful media.
          if (!content.textContent.trim() && !content.querySelector('img, video, iframe, audio, table, svg')) return;
          if (!sections.has(category)) sections.set(category, document.createDocumentFragment());
          sections.get(category).append(content);
        };

        // DOM ranges preserve nested wrappers used by products such as The Loop.
        addSection('description', null, headings[0].element);
        headings.forEach((heading, index) => {
          addSection(heading.category, heading.element, headings[index + 1]?.element);
        });
        if (!sections.size) return;

        const rows = document.createDocumentFragment();
        for (const category of ['description', 'details', 'care']) {
          if (!sections.has(category)) continue;
          const row = document.createElement('details');
          row.className = 'daayraa-product-row';
          row.dataset.productCategory = category;
          const summary = document.createElement('summary');
          summary.className = 'daayraa-product-row__summary';
          const label = document.createElement('span');
          label.textContent = this.dataset[`${category}Label`] || category;
          const toggle = document.createElement('span');
          toggle.className = 'daayraa-product-row__toggle';
          toggle.setAttribute('aria-hidden', 'true');
          summary.append(label, toggle);
          const content = document.createElement('div');
          content.className = 'daayraa-product-row__content rte';
          content.append(sections.get(category));
          row.append(summary, content);
          rows.append(row);
        }
        // Replace only after every section is built, keeping a complete fallback on failure.
        originalRow.replaceWith(rows);
      } catch (error) {
        console.warn('Daayraa: keeping the complete product description.', error);
      }
    }
  }

  customElements.define('daayraa-product-accordions', DaayraaProductAccordions);
})();
